import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatDialogModule } from '@angular/material/dialog';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsButtonModule } from '@cds/ng-web-components/button';

import { UserAgreementPopupComponent } from './user-agreement-popup.component';
import { CdsProgressModule } from '@cds/ng-web-components/progress';

@NgModule({
  imports: [CommonModule, MatDialogModule, CdsIconModule, CdsPopupModule, CdsLanguageModule, CdsButtonModule, CdsProgressModule, UserAgreementPopupComponent],
})
export class UserAgreementPopupModule {}
